var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 2L8 8L2 2","stroke":"#282725","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Arrow.defaultProps = {"width":"16","height":"10","viewBox":"0 0 16 10","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
